import type SigsInfo from '../store/schema/SigsInfo';
import type SxSExtendedViewState from '../store/schema/SxSExtendedViewState';
import type SxSReadingPaneState from '../store/schema/SxSReadingPaneState';
import type { SxSCustomization } from '../store/schema/SxSStore';
import { action } from 'satcheljs';

interface OnSxSReadingPaneChangeActionMessage {
    readingPaneState: SxSReadingPaneState | null;
    sxsId: string | null;
}
export const onSxSReadingPaneChange: (
    readingPaneState: SxSReadingPaneState | null,
    sxsId: string | null
) => OnSxSReadingPaneChangeActionMessage = action(
    'onSxSReadingPaneChange',
    (
        readingPaneState: SxSReadingPaneState | null,
        sxsId: string | null
    ): OnSxSReadingPaneChangeActionMessage => ({
        readingPaneState,
        sxsId,
    })
);

interface OnBeforeSxSReadingPaneChangeActionMessage {
    id: string;
}
export const onBeforeSxSReadingPaneChange: (
    id: string
) => OnBeforeSxSReadingPaneChangeActionMessage = action(
    'onBeforeSxSReadingPaneChange',
    (id: string): OnBeforeSxSReadingPaneChangeActionMessage => ({
        id,
    })
);

interface ShowSxSActionMessage {
    customization: SxSCustomization | null;
    extendedViewState: SxSExtendedViewState;
    sxsId: string | null;
    sigsInfo: SigsInfo | undefined;
}
export const showSxS: (
    customization: SxSCustomization | null,
    extendedViewState: SxSExtendedViewState,
    sxsId: string | null,
    sigsInfo?: SigsInfo
) => ShowSxSActionMessage = action(
    'showSxS',
    (
        customization: SxSCustomization | null,
        extendedViewState: SxSExtendedViewState,
        sxsId: string | null,
        sigsInfo?: SigsInfo
    ): ShowSxSActionMessage => ({
        customization,
        extendedViewState,
        sxsId,
        sigsInfo,
    })
);

interface OnComposeStateChangeActionMessage {
    composeId: string | null;
    sxsId: string | null;
}
export const onComposeStateChange: (
    composeId: string | null,
    sxsId: string | null
) => OnComposeStateChangeActionMessage = action(
    'onComposeStateChange',
    (composeId: string | null, sxsId: string | null): OnComposeStateChangeActionMessage => ({
        composeId,
        sxsId,
    })
);

interface OnCustomizationChangeActionMessage {
    customization: SxSCustomization | null;
    sxsId: string | null;
}
export const onCustomizationChange: (
    customization: SxSCustomization | null,
    sxsId: string | null
) => OnCustomizationChangeActionMessage = action(
    'onCustomizationChange',
    (
        customization: SxSCustomization | null,
        sxsId: string | null
    ): OnCustomizationChangeActionMessage => ({
        customization,
        sxsId,
    })
);
